var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.378,
    height: 27.394,
    viewBox: "0 0 30.378 27.394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.378,
    height: 27.394,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.849,5.36S22.033.619,24.343,12.046c0,0,8.51,2.067,3.4,9.847",
    fill: "none",
    stroke: "#091638",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.782,6.941A4.973,4.973,0,0,0,7.08,9.98,6.477,6.477,0,0,0,1,16.788c-.122,6.565,7.051,6.565,7.051,6.565H24.464",
    fill: "none",
    stroke: "#091638",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 25.195,
    y2: 25.394,
    transform: "translate(3.035 1)",
    fill: "none",
    stroke: "#091638",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.70a8b9cf1af7fe3a3c6a96fce14ed45c.svg";
export { ForwardRef as ReactComponent };